// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/weather_forecast_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { WeatherForecastPointSelectionState } from "../../bfftypes/v1/weather_forecast_point_selection_state_pb";
import { file_bfftypes_v1_weather_forecast_point_selection_state } from "../../bfftypes/v1/weather_forecast_point_selection_state_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/weather_forecast_model.proto.
 */
export const file_bffuser_v1_weather_forecast_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_weather_forecast_point_selection_state, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * DailyForecastSelection is the resolved weather/temperature source for one
 * target date. Mirrors internalapi.v1.DailyForecastSelection.
 *
 * @generated from message bffuser.v1.DailyForecastSelection
 */
export type DailyForecastSelection = Message<"bffuser.v1.DailyForecastSelection"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.WeatherSource weather_source = 2;
   */
  weatherSource: WeatherSource;

  /**
   * @generated from field: bffuser.v1.TemperatureSource temperature_source = 3;
   */
  temperatureSource: TemperatureSource;
};

/**
 * Describes the message bffuser.v1.DailyForecastSelection.
 * Use `create(DailyForecastSelectionSchema)` to create a new message.
 */
export const DailyForecastSelectionSchema: GenMessage<DailyForecastSelection> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_model, 0);

/**
 * AreaWeatherForecast is the BFF mirror of the backend 8-metric weather
 * forecast bundle for a single electricity area (= live JMA forecast from
 * BigQuery). Shape mirrors internalapi.v1.AreaWeatherForecast.
 *
 * @generated from message bffuser.v1.AreaWeatherForecast
 */
export type AreaWeatherForecast = Message<"bffuser.v1.AreaWeatherForecast"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Resolved point display name (e.g. "札幌"). Empty when is_available=false.
   *
   * @generated from field: string resolved_point_name = 2;
   */
  resolvedPointName: string;

  /**
   * False when the resolved point has no JMA mapping (今後実装予定); all series
   * are then empty.
   *
   * @generated from field: bool is_available = 4;
   */
  isAvailable: boolean;

  /**
   * The adopted latest report. Absent when unavailable or none in range.
   *
   * @generated from field: optional google.protobuf.Timestamp report_datetime = 5;
   */
  reportDatetime?: Timestamp;

  /**
   * @generated from field: repeated bffuser.v1.TemperaturePoint temperature = 6;
   */
  temperature: TemperaturePoint[];

  /**
   * @generated from field: repeated bffuser.v1.TemperatureExtremaPoint temperature_extrema = 14;
   */
  temperatureExtrema: TemperatureExtremaPoint[];

  /**
   * @generated from field: repeated bffuser.v1.WeatherPoint weather = 9;
   */
  weather: WeatherPoint[];

  /**
   * @generated from field: repeated bffuser.v1.WeatherPoint weather_3hour = 10;
   */
  weather3hour: WeatherPoint[];

  /**
   * @generated from field: repeated bffuser.v1.WeeklyTemperaturePoint weekly_temperature = 11;
   */
  weeklyTemperature: WeeklyTemperaturePoint[];

  /**
   * @generated from field: repeated bffuser.v1.WeeklyWeatherPoint weekly_weather = 12;
   */
  weeklyWeather: WeeklyWeatherPoint[];

  /**
   * @generated from field: repeated bffuser.v1.WeeklyTemperatureNormalPoint weekly_temperature_normal = 13;
   */
  weeklyTemperatureNormal: WeeklyTemperatureNormalPoint[];

  /**
   * Per-date resolved source (spec AC-WD-006/007/008). One entry per date in
   * [target_date_from, target_date_to], ascending order; no date is omitted.
   *
   * @generated from field: repeated bffuser.v1.DailyForecastSelection daily_selection = 15;
   */
  dailySelection: DailyForecastSelection[];

  /**
   * Why the point behind resolved_point_name was chosen (明示選択 / 未設定で
   * 既定 / 失効で既定). Replaces the retired is_default_fallback bool.
   *
   * @generated from field: bfftypes.v1.WeatherForecastPointSelectionState point_selection_state = 16;
   */
  pointSelectionState: WeatherForecastPointSelectionState;
};

/**
 * Describes the message bffuser.v1.AreaWeatherForecast.
 * Use `create(AreaWeatherForecastSchema)` to create a new message.
 */
export const AreaWeatherForecastSchema: GenMessage<AreaWeatherForecast> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_model, 1);

/**
 * TemperaturePoint is one temperature reading (℃) at a target datetime.
 *
 * @generated from message bffuser.v1.TemperaturePoint
 */
export type TemperaturePoint = Message<"bffuser.v1.TemperaturePoint"> & {
  /**
   * @generated from field: google.protobuf.Timestamp target_datetime = 1;
   */
  targetDatetime?: Timestamp;

  /**
   * @generated from field: optional google.type.Decimal temperature = 2;
   */
  temperature?: Decimal;
};

/**
 * Describes the message bffuser.v1.TemperaturePoint.
 * Use `create(TemperaturePointSchema)` to create a new message.
 */
export const TemperaturePointSchema: GenMessage<TemperaturePoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_model, 2);

/**
 * TemperatureExtremaPoint is the near-term daily high/low (℃) for a target
 * date. The JMA source publishes one row per target date (up to ~2 days ahead);
 * today's row may carry only the max (the morning low has passed), so both
 * bounds are optional.
 *
 * @generated from message bffuser.v1.TemperatureExtremaPoint
 */
export type TemperatureExtremaPoint = Message<"bffuser.v1.TemperatureExtremaPoint"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: optional google.type.Decimal max_temp = 2;
   */
  maxTemp?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal min_temp = 3;
   */
  minTemp?: Decimal;
};

/**
 * Describes the message bffuser.v1.TemperatureExtremaPoint.
 * Use `create(TemperatureExtremaPointSchema)` to create a new message.
 */
export const TemperatureExtremaPointSchema: GenMessage<TemperatureExtremaPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_model, 3);

/**
 * WeatherPoint is a weather-condition reading (text + optional code).
 *
 * @generated from message bffuser.v1.WeatherPoint
 */
export type WeatherPoint = Message<"bffuser.v1.WeatherPoint"> & {
  /**
   * @generated from field: google.protobuf.Timestamp target_datetime = 1;
   */
  targetDatetime?: Timestamp;

  /**
   * @generated from field: string weather_text = 2;
   */
  weatherText: string;

  /**
   * @generated from field: optional int32 weather_code = 3;
   */
  weatherCode?: number;
};

/**
 * Describes the message bffuser.v1.WeatherPoint.
 * Use `create(WeatherPointSchema)` to create a new message.
 */
export const WeatherPointSchema: GenMessage<WeatherPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_model, 4);

/**
 * WeeklyTemperaturePoint is a weekly forecast high/low (℃) for a target date.
 *
 * @generated from message bffuser.v1.WeeklyTemperaturePoint
 */
export type WeeklyTemperaturePoint = Message<"bffuser.v1.WeeklyTemperaturePoint"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: optional google.type.Decimal max_temp = 2;
   */
  maxTemp?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal min_temp = 3;
   */
  minTemp?: Decimal;
};

/**
 * Describes the message bffuser.v1.WeeklyTemperaturePoint.
 * Use `create(WeeklyTemperaturePointSchema)` to create a new message.
 */
export const WeeklyTemperaturePointSchema: GenMessage<WeeklyTemperaturePoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_model, 5);

/**
 * WeeklyWeatherPoint is a weekly weather-condition reading for a target date.
 *
 * @generated from message bffuser.v1.WeeklyWeatherPoint
 */
export type WeeklyWeatherPoint = Message<"bffuser.v1.WeeklyWeatherPoint"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: string weather_text = 2;
   */
  weatherText: string;

  /**
   * @generated from field: optional int32 weather_code = 3;
   */
  weatherCode?: number;
};

/**
 * Describes the message bffuser.v1.WeeklyWeatherPoint.
 * Use `create(WeeklyWeatherPointSchema)` to create a new message.
 */
export const WeeklyWeatherPointSchema: GenMessage<WeeklyWeatherPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_model, 6);

/**
 * WeeklyTemperatureNormalPoint is the weekly climatological normal high/low
 * (平年値, ℃) for a target date.
 *
 * @generated from message bffuser.v1.WeeklyTemperatureNormalPoint
 */
export type WeeklyTemperatureNormalPoint = Message<"bffuser.v1.WeeklyTemperatureNormalPoint"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: optional google.type.Decimal normal_max_temp = 2;
   */
  normalMaxTemp?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal normal_min_temp = 3;
   */
  normalMinTemp?: Decimal;
};

/**
 * Describes the message bffuser.v1.WeeklyTemperatureNormalPoint.
 * Use `create(WeeklyTemperatureNormalPointSchema)` to create a new message.
 */
export const WeeklyTemperatureNormalPointSchema: GenMessage<WeeklyTemperatureNormalPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_model, 7);

/**
 * WeatherSource identifies which JMA forecast source a day's weather (天気)
 * was resolved from (spec docs/specs/demand/jma-weather-data.md AC-WD-009 /
 * AC-WD-010 priority order: VPFD > PREFECTURAL > WEEKLY). Mirrors
 * internalapi.v1.WeatherSource.
 *
 * @generated from enum bffuser.v1.WeatherSource
 */
export enum WeatherSource {
  /**
   * @generated from enum value: WEATHER_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEATHER_SOURCE_VPFD = 1;
   */
  VPFD = 1,

  /**
   * @generated from enum value: WEATHER_SOURCE_PREFECTURAL = 2;
   */
  PREFECTURAL = 2,

  /**
   * @generated from enum value: WEATHER_SOURCE_WEEKLY = 3;
   */
  WEEKLY = 3,

  /**
   * No source had a row for the date (spec 未定義パスの明示).
   *
   * @generated from enum value: WEATHER_SOURCE_UNAVAILABLE = 4;
   */
  UNAVAILABLE = 4,
}

/**
 * Describes the enum bffuser.v1.WeatherSource.
 */
export const WeatherSourceSchema: GenEnum<WeatherSource> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_weather_forecast_model, 0);

/**
 * TemperatureSource identifies which JMA forecast source a day's high/low
 * temperature was resolved from. Mirrors internalapi.v1.TemperatureSource.
 *
 * @generated from enum bffuser.v1.TemperatureSource
 */
export enum TemperatureSource {
  /**
   * @generated from enum value: TEMPERATURE_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEMPERATURE_SOURCE_PREFECTURAL = 1;
   */
  PREFECTURAL = 1,

  /**
   * @generated from enum value: TEMPERATURE_SOURCE_WEEKLY = 2;
   */
  WEEKLY = 2,

  /**
   * @generated from enum value: TEMPERATURE_SOURCE_UNAVAILABLE = 3;
   */
  UNAVAILABLE = 3,
}

/**
 * Describes the enum bffuser.v1.TemperatureSource.
 */
export const TemperatureSourceSchema: GenEnum<TemperatureSource> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_weather_forecast_model, 1);

